import axios from 'axios';

export const getModelSpecs = (model) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        'https://us-central1-suzuki-hs-webservice.cloudfunctions.net/api/latest-specs'
      )
      .then((res) => {
        let modelData = getModelData(model);
        let modelName = modelData.modelName;
        let modelVariant = modelData.modelVariation;
        res.data.results.forEach((item) => {
          if (
            item.values.model === modelName &&
            item.values.variation === modelVariant
          ) {
            resolve(item.values);
          }
        });
        reject('No data found for model ', modelName);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const parseToKeyValuePairs = (modelData) => {
  let newObj = [];
  for (const [key, value] of Object.entries(modelData)) {
    newObj.push({ key: key.split('_').join(' '), value: value });
  }

  return newObj;
};

const getModelData = (model) => {
  if (!isNaN(parseFloat(model.split(' ')[1]))) {
    let data = {};

    data.modelName = model.split(' ')[0];
    data.modelVariation = model.split(' ').slice(1).join(' ');

    return data;
  } else {
    let data = {};

    let arr = model.split(' ');

    data.modelName = `${arr[0]} ${arr[1]}`;
    data.modelVariation = model.split(' ').slice(2).join(' ');

    return data;
  }
};

export const getThumbnailURL = (data) => {
  const img = data.filter((item) => item.key === 'thumbnail');
  return img[0].value.url;
};
